import {
  TRANSLATIONS,
  TRANSLATION_NAMESPACE,
} from "@bfc-software/bfc-web-ui/i18n/resources";

export type LanguageKey = keyof typeof TRANSLATIONS;
export type NameSpaceKeys =
  (typeof TRANSLATION_NAMESPACE)[keyof typeof TRANSLATION_NAMESPACE];

export const SUPPORTED_LOCALES: Array<LanguageKey> = ["en"];
export const DEFAULT_LOCALE = "en";
export const cookieName = "i18next";

type Options = {
  lang: string;
  namespace: NameSpaceKeys;
};

export function getOptions({ lang, namespace }: Options) {
  return {
    // debug: true,
    resources: TRANSLATIONS,
    supportedLngs: SUPPORTED_LOCALES,
    fallbackLng: DEFAULT_LOCALE,
    lng: lang,
    ns: namespace,
  };
}
